import React from 'react';
import { connect } from 'react-redux';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { browserHistory } from 'react-router';
import withWidth, { LARGE, SMALL } from 'material-ui/utils/withWidth';
import PropTypes from 'prop-types';
import PermIdentity from 'material-ui/svg-icons/action/perm-identity';
import Settings from 'material-ui/svg-icons/action/settings';
import SettingsApplications from 'material-ui/svg-icons/action/settings-applications';
import Warning from 'material-ui/svg-icons/alert/warning';
import SupervisorAccount from 'material-ui/svg-icons/action/supervisor-account';
import Event from 'material-ui/svg-icons/action/event';
import VpnKey from 'material-ui/svg-icons/communication/vpn-key';
import ViewList from 'material-ui/svg-icons/action/view-list';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import Loading from '../components/Loading';
import Header from '../components/Header';
import LeftDrawer from '../components/LeftDrawer';
import Theme, { drawerTextColor, headerTextColor, useDrawer } from '../theme';
import * as authActions from '../redux/modules/auth';
import i18n from '../translations/i18n';

/*
Styled components
 */

const Container = styled.div`
  margin: 80px 20px 20px 15px;
  padding-left: ${props => `${props.paddingLeft}px !important`};
`;

const MenuIcon = styled.div`
  height: 20px !important;
  width: 20px !important;
  margin: 14px !important;
  left: 11px !important;
`;

/*
PropTypes / DefaultProps
 */
const propTypes = {
  children: PropTypes.element,
  width: PropTypes.number,
  authenticated: PropTypes.bool,
  authenticating: PropTypes.bool,
  checkAuth: PropTypes.func,
  t: PropTypes.func,
  currentUser: PropTypes.any,
};

const defaultProps = {
  width: 0,
  authenticated: false,
  authenticating: false,
};

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      navDrawerOpen: useDrawer,
    };
  }

  /*
    Lifecycle methods
   */
  componentWillMount() {
    this.props.checkAuth();
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.authenticated && !nextProps.authenticating) {
      browserHistory.push('/login');
      return;
    }

    if (this.props.width !== nextProps.width) {
      this.setState({ navDrawerOpen: nextProps.width === LARGE });
    }
  }

  /*
    Custom methods
   */
  handleChangeRequestNavDrawer = () => {
    this.setState({
      navDrawerOpen: !this.state.navDrawerOpen,
    });
  };

  render() {
    const { navDrawerOpen } = this.state;
    const paddingLeftDrawerOpen = 246;
    const iconColor = useDrawer ? drawerTextColor : headerTextColor;

    const { currentUser } = this.props;

    const menus = [
      {
        text: this.props.t('paketbox'),
        icon: <ViewList color={iconColor} />,
        link: '/packetboxes',
      },
      {
        text: this.props.t('user'),
        icon: <SupervisorAccount color={iconColor} />,
        link: '/end-users',
      },
      {
        text: this.props.t('authorizations'),
        icon: <VpnKey color={iconColor} />,
        link: '/authorizations',
      },
      { text: this.props.t('events'), icon: <Event color={iconColor} />, link: '/events' },
      {
        text: this.props.t('messages'),
        icon: <PermIdentity color={iconColor} />,
        link: '/messages',
      },
      {
        text: this.props.t('lora_configurations'),
        icon: <Settings color={iconColor} />,
        link: '/lora-configs',
      },
      { text: this.props.t('alerts'), icon: <Warning color={iconColor} />, link: '/alerts' },
      {
        text: this.props.t('alert_types'),
        icon: <SettingsApplications color={iconColor} />,
        link: '/alert-types',
      },
      {
        text: this.props.t('accounts'),
        icon: <PermIdentity color={iconColor} />,
        link: '/accounts',
      },
    ];

    if (this.props.authenticating || !this.props.authenticated) {
      return (
        <MuiThemeProvider muiTheme={Theme}>
          <Loading />
        </MuiThemeProvider>
      );
    }

    return (
      <MuiThemeProvider muiTheme={Theme}>
        <div>
          <Header
            style={{ paddingLeft: navDrawerOpen ? paddingLeftDrawerOpen : 0 }}
            menus={menus}
            user={this.props.currentUser}
            handleChangeRequestNavDrawer={this.handleChangeRequestNavDrawer}
          />

          {useDrawer && <LeftDrawer navDrawerOpen={navDrawerOpen} menus={menus} />}

          <Container
            paddingLeft={navDrawerOpen && this.props.width !== SMALL ? paddingLeftDrawerOpen : 0}
          >
            {this.props.children}
          </Container>
        </div>
      </MuiThemeProvider>
    );
  }
}

App.propTypes = propTypes;
App.defaultProps = defaultProps;

function mapStateToProps(state) {
  return {
    authenticated: state.auth.authenticated,
    authenticating: state.auth.authenticating,
    currentUser: state.auth.current,
  };
}

const extended = translate(['translations'], { i18n })(App);
export default withWidth()(connect(mapStateToProps, authActions)(extended));



// WEBPACK FOOTER //
// ./src/containers/App.js